export default {
  apiDomain: 'https://portal.farcecrew.de/api',
  appDomain: 'https://portal.farcecrew.de',
  envSuffix: '',
  refresh: 5,
  debug: false
};
